/* eslint-disable */

//tslint:disable

import { IModel, IModelResponse } from '@cian/http-api/shared/model';

export type TSetOfferLabelModel = IModel<ISetOfferLabelRequest, TSetOfferLabelResponse>;

export interface ISetOfferLabelRequest {
  /** ID объявления **/
  offerId: number;
  /** Показывать лейбл **/
  showLabel: boolean;
}

export type TSetOfferLabelResponse = ISetOfferLabelResponse200 | ISetOfferLabelResponse400;

export interface ISetOfferLabelResponse200 extends IModelResponse<ISetOfferLabelResponse> {
  statusCode: 200;
}

export interface ISetOfferLabelResponse400 extends IModelResponse<ISetOfferLabelResponseError> {
  statusCode: 400;
}

export interface ISetOfferLabelResponse {
  /** Статус выполнения запроса бэком **/
  status: EStatus;
}

export interface ISetOfferLabelResponseError {
  errors: any[];
  message: string;
}

export type TResponses = ISetOfferLabelResponse | ISetOfferLabelResponseError;

export enum EStatus {
  /** Запрос обработан успешно **/
  Ok = 'ok',
}

export interface IMappers<TResponse200, TResponse400> {
  200(response: ISetOfferLabelResponse): TResponse200;
  400(response: ISetOfferLabelResponseError): TResponse400;
}
